export const CONVERSION_EVENTS_WIZARD_TYPE = "conversion-events";
